export default __webpack_public_path__ + "static/media/ButtonPlus.edd67f7e.svg";